var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { ApiEditSpace } from '@/infrastructure/api-functions/api-edit-space';
let EditSpaceRepositoryImpl = class EditSpaceRepositoryImpl {
    constructor(_apiEditSpace) {
        this._apiEditSpace = _apiEditSpace;
    }
    async editSpace(data) {
        const request = {
            space_id: data.spaceId,
            space_name: data.spaceName,
            label_ids: data.tags,
        };
        if (data.objectKey) {
            request.space_s3_key = data.objectKey;
        }
        else {
            request.space_icon = data.buildInIconId;
        }
        const resp = await this._apiEditSpace.updateSpace(request);
        return {
            spaceName: resp.space_name,
            buildInIconId: resp.space_icon,
            iconImageUrl: resp.space_s3_key,
            tags: resp.label_ids,
            spaceId: resp.space_id,
        };
    }
};
EditSpaceRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(ApiEditSpace)),
    __metadata("design:paramtypes", [typeof (_a = typeof ApiEditSpace !== "undefined" && ApiEditSpace) === "function" ? _a : Object])
], EditSpaceRepositoryImpl);
export { EditSpaceRepositoryImpl };
